// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"40":"f757f382","256":"315070c2","276":"8bff24e6","413":"44d1441b","720":"451057cb","919":"959af6de","989":"72c43f87"}[chunkId] + ".chunk.css";
};